module.exports = __webpack_public_path__ + "img/active-building.e3aa7758.svg";